import { ReservationInterface } from '../interfaces/reservation';
import { User } from "./user";
import { Inspection } from "./inspection";

export class Reservation implements ReservationInterface {
    id_reservation?: number;
    fk_id_user?: number;
    user: User;
    fk_id_inspection?: number;
    inspection: Inspection;
    date: Date;
    state: number;

    constructor() {
        this.fk_id_user = 0;
        this.user = new User();
        this.fk_id_inspection = 0;
        this.inspection = new Inspection();
        this.date = new Date();
        this.state = 0;
    }
}
